<script lang="ts" setup>
import { computed } from 'vue'

import type { Release } from './ReleaseNotes.vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  releases: Release[]
}>()

const selectedIndex = defineModel<number>('selectedIndex', { required: true })

const sortedReleases = computed(() => {
  return props.releases.map((release, index) => ({
    release,
    index,
  }))
})
</script>

<template>
  <div
    class="w-64 overflow-y-auto border-r border-gray-200 [scrollbar_width:_thin] dark:border-zinc-700"
  >
    <div class="p-4">
      <h3 class="mb-3 text-sm font-semibold text-gray-900 dark:text-white">Alle Versionen</h3>

      <div class="space-y-1">
        <button
          v-for="{ release, index } in sortedReleases"
          :key="index"
          type="button"
          class="w-full rounded-md px-3 py-2 text-left text-sm transition-colors"
          :class="{
            'bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-300':
              index === selectedIndex,
            'text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-zinc-800':
              index !== selectedIndex,
          }"
          @click="selectedIndex = index"
        >
          <div class="truncate font-medium">
            {{ release.name }}
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
